"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_select_1 = require("react-select");
var tokens_1 = require("../../../tokens");
var styled_1 = __importDefault(require("../../../styled"));
var icon_1 = __importDefault(require("../../icon"));
var StyledCloseIcon = styled_1.default(icon_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n  margin-right: ", "px;\n\n  svg {\n    display: block;\n  }\n"], ["\n  pointer-events: none;\n  margin-right: ", "px;\n\n  svg {\n    display: block;\n  }\n"])), tokens_1.spacing.unit);
exports.ClearIndicator = function (props) { return (React.createElement(react_select_1.components.ClearIndicator, __assign({}, props),
    React.createElement(StyledCloseIcon, { name: "close", size: "14", color: "default" }))); };
var templateObject_1;
//# sourceMappingURL=clear-indicator.js.map